import { useSelector } from 'react-redux';

const selector = (state) => state.cartData;

function useCart() {
  return useSelector(selector);
}

export default useCart
